import { gql } from 'apollo-boost';

export const GET_WORKSPACE_INFO = gql`
  query getWorkspaceInfo {
    coach {
      providerWorkspace {
        role
        id
        staff {
          id
          displayName
          embedInfoSeen
          staffSetting {
            id
            advancedSettings {
              showContacts
              showSchedules
              showAnalytics
            }
          }
        }
        workspace {
          id
          createdAt
          region {
            tzid
            countryCode
          }
          currency {
            symbol
          }
          partnersSubscriptions(filter: { activeEq: true, productKindEq: plan }) {
            id
            active
            stripeStatus
            paywallOverride {
              klassesLimit
              providerPlansLimit
            }
            fituPrice {
              id
              amount
              interval
              fituProduct {
                roledStaffsLimit
                vimeo
                label
                slug
                klassesLimit
                providerPlansLimit
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_STAFFS_ROLES = gql`
  query getStaffsRoles {
    staffs {
      collection {
        providerWorkspace {
          role
        }
      }
    }
  }
`;

export const GET_WEBSITE_INFO = gql`
  query coachAndPartnersPreferencesStorefrontTabs {
    website: getStorefront {
      logoUrl
      name
    }
    coach: workspace {
      currentLang
      currency {
        symbol
        countryCode
      }
      region {
        tzid
      }
      id
      email
      subdomain
      customDomain {
        active
        hostname
      }
      scheduleSetting {
        adminDisplayDays
      }
    }
    onlineBranch: onlineBranch {
      id
    }
    tabs: partnersPreferencesStorefrontTabs {
      collection {
        active
        slug
      }
    }
  }
`;

export const SEARCH_CLIENTS_UNIFIED = (
  scheduleCheckout,
  oneFitFlag,
  googleReserveFlag = false,
  firstTimeBadgeFlag = false,
  fitpassIntegrationFlag = false
) => {
  return gql`
    query partnersCustomers($search: String, $page: Int!, $limit: Int!${
      scheduleCheckout ? `, $branchId: Int!` : ``
    }) {
      clients: partnersCustomers(
        search: $search,
        page: $page,
        limit: $limit
      ) {
        collection {
          id
          segment
          user {
            id
            fullname
            email
            photoUrls
            ${
              scheduleCheckout
                ? `
            bookedSchedule: bookingsExist(filter: {
              branchScheduleIdEq: $branchId,
              statusEq: booked
            })
            activePlans: userSubscriptions(
              filter: { scopeEq: actives, stripeStatusNotIn: [incomplete_expired] }
            ) {
              id
              providerPlanId
            }`
                : ``
            }
          }
          wellhubId
          ${oneFitFlag ? `onefitUser` : ``}
          totalpassUser
          ${fitpassIntegrationFlag ? `fitpassUser` : ``}
          ${googleReserveFlag ? `googleReserve` : ``}
          ${firstTimeBadgeFlag ? `attendanceCount\n          bookingCount` : ``}
          personalDetails {
            birthdate
          }
        }
        metadata {
          totalPages
        }
      }
    }
  `;
};

export const SEARCH_CLIENT_ID = (
  oneFitFlag,
  googleReserveFlag = false,
  firstTimeBadgeFlag = false,
  fitpassIntegrationFlag = false
) => {
  return gql`
  query partnersCustomer($id: Int!) {
    client: partnersCustomer(id: $id) {
      id
      segment
      user {
        id
        fullname
        email
        photoUrls
        activePlans: userSubscriptions(
          filter: { scopeEq: actives, stripeStatusNotIn: [incomplete_expired] }
        ) {
          id
          providerPlanId
        }
      }
      customerPaymentMethods {
        id
        name
        billingAddress
        default
        paymentType
        paymentGateway
        brand
        expires
        fourDigits
        paymentType
      }
      wellhubId
      ${oneFitFlag ? `onefitUser` : ``}
      totalpassUser
      ${fitpassIntegrationFlag ? `fitpassUser` : ``}
      ${googleReserveFlag ? `googleReserve` : ``}
      ${firstTimeBadgeFlag ? `attendanceCount\n      bookingCount` : ``}
      personalDetails {
        id
        birthdate
        gender
        phoneNumber
      }
    }
  }
  `;
};

export const UPLOAD_EMAIL_IMAGE = gql`
  mutation CreateEmailTemplateImage($input: CreateEmailTemplateImageInput!) {
    createEmailTemplateImage(input: $input) {
      emailTemplateImage {
        fileUrl
      }
    }
  }
`;

export const GET_PRODUCTS_COUNTS = gql`
  query prouctsCounts {
    staffsCount: staffs(filter: { providerWorkspacesRoleIn: [admin] }) {
      metadata {
        totalCount
      }
    }
    appointmentServicesCount: appointmentServices(filter: { statusEq: active }) {
      metadata {
        totalCount
      }
    }
    coursesCount: courses(filter: { statusEq: published }) {
      metadata {
        totalCount
      }
    }
    klassesCount: klasses(filter: { activityKindEq: klass }) {
      metadata {
        totalCount
      }
    }
    eventCount: klasses(filter: { activityKindEq: event }) {
      metadata {
        totalCount
      }
    }
    membershipCount: userSubscriptions(filter: { stripeStatusEq: active, oneTimeEq: false }) {
      metadata {
        totalCount
      }
    }
  }
`;

export const GET_OVERRIDE_PLAN_FEATURES = (
  oneFitIntegrationFlag,
  googleReserveIntegrationFlag,
  fitpassIntegrationFlag
) => {
  return gql`
  query coach {
    coach: workspace {
      subdomain
      partnersSubscriptions (filter: {
        activeEq: true
        productKindEq: plan
      }) {
        paywallOverride {
          roledStaffsLimit
          activeUsers
          rooms
          vimeo
          wellhubEnabled
          totalpassEnabled
          ${oneFitIntegrationFlag ? `onefitEnabled` : ``}
          ${googleReserveIntegrationFlag ? `googleReserveEnabled` : ``}
          ${fitpassIntegrationFlag ? `fitpassEnabled` : ``}
        }
        fituPrice {
          fituProduct {
            roledStaffsLimit
            activeUsers
            rooms
            vimeo
            wellhubEnabled
            totalpassEnabled
            ${oneFitIntegrationFlag ? `onefitEnabled` : ``}
            ${googleReserveIntegrationFlag ? `googleReserveEnabled` : ``}
            ${fitpassIntegrationFlag ? `fitpassEnabled` : ``}
          }
        }
      }
    }
  }`;
};

export const GET_PROVIDER_PLANS_BOOKING_CONFIG = gql`
  query providerPlans {
    providerPlans {
      collection {
        id
        allowMultipleBookings
      }
    }
  }
`;

export const GET_FEATURE_FLAGS = gql`
  query featureFlags {
    featureFlags
  }
`;

// Shared by the business settings form and by any surface that changes the
// coach language. The `branch` input is a partial: send only the fields to
// update, always alongside the branch id.
export const UPDATE_ONLINE_BRANCH = gql`
  mutation UpdateOnlineBranch($input: UpdateOnlineBranchInput!) {
    updateOnlineBranch(input: $input) {
      success
      errors
    }
  }
`;
